export enum SentenceTypeEnum {
  Default = 1,
  Regex = 2,
  XPath = 3,
}
